(function (Translator) {
    // pl
    Translator.add("administration.user_search_button", "Szukaj", "EvpAdministrationBundle", "pl");
    Translator.add("administration.user_search_label", "ID u\u017cytkownika", "EvpAdministrationBundle", "pl");
    Translator.add("forbidden", "Niedozwolone", "EvpAdministrationBundle", "pl");
    Translator.add("internal_server_error", "B\u0142\u0105d serwera", "EvpAdministrationBundle", "pl");
    Translator.add("invalid_code", "Nieprawid\u0142owy kod", "EvpAdministrationBundle", "pl");
    Translator.add("invalid_grant", "Dost\u0119p nie zostal zapewniony", "EvpAdministrationBundle", "pl");
    Translator.add("invalid_parameters", "Nieprawid\u0142owe parametry", "EvpAdministrationBundle", "pl");
    Translator.add("invalid_request", "Nieprawid\u0142owe zapytanie", "EvpAdministrationBundle", "pl");
    Translator.add("invalid_state", "Nieprawid\u0142owy status", "EvpAdministrationBundle", "pl");
    Translator.add("limits_exceeded", "Limit zosta\u0142 osi\u0105gni\u0119ty", "EvpAdministrationBundle", "pl");
    Translator.add("logout", "Wyloguj si\u0119", "EvpAdministrationBundle", "pl");
    Translator.add("not_acceptable", "Nieakceptowane", "EvpAdministrationBundle", "pl");
    Translator.add("not_found", "Nie znaleziono", "EvpAdministrationBundle", "pl");
    Translator.add("pagination.first", "Pierwszy", "EvpAdministrationBundle", "pl");
    Translator.add("pagination.last", "Ostatni ", "EvpAdministrationBundle", "pl");
    Translator.add("pagination.next", "Dalej", "EvpAdministrationBundle", "pl");
    Translator.add("pagination.page_out_of", "z", "EvpAdministrationBundle", "pl");
    Translator.add("pagination.previous", "Wr\u00f3\u0107", "EvpAdministrationBundle", "pl");
    Translator.add("rate_limit_exceeded", "Limit zosta\u0142 osi\u0105gni\u0119ty", "EvpAdministrationBundle", "pl");
    Translator.add("unauthorized", "Dost\u0119p nie zostal zapewniony", "EvpAdministrationBundle", "pl");
})(Translator);
